<!-- 电子班牌系统 -->
<!-- 电子班牌系统 -->
<template>
  <div class="class-card-page">
    <!-- 1. Banner 区域 (深色科技风) -->
       <!-- 1. Banner 区域 (深色科技风) -->
    <section class="cc-banner">
      <div class="banner-overlay"></div>
      <div class="container">
        <div class="banner-content">
          <h1>智慧校园<br>电子班牌系统</h1>
          <p class="subtitle">让班级管理更智能、让校园生活更高效</p>
          
          <div class="banner-features">
            <div class="bf-item">
              <div class="bf-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div>
                <h4>AI语音识别</h4>
                <p>精准识别敏感风险</p>
              </div>
            </div>
            
            <div class="bf-item">
              <div class="bf-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div>
                <h4>敏感词预警</h4>
                <p>实时感知风险事件</p>
              </div>
            </div>
            
            <div class="bf-item">
              <div class="bf-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div>
                <h4>一键紧急呼救</h4>
                <p>快速触发应急响应</p>
              </div>
            </div>
            
            <div class="bf-item">
              <div class="bf-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div>
                <h4>安防联动响应</h4>
                <p>多系统协同处置</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2. 核心功能 (白色背景，网格布局) -->
   <!-- 2. 核心功能 -->
<section class="cc-features">
  <div class="container">
    <div class="section-title">
      <h2>核心功能</h2>
      <p>一屏汇聚班级信息，日常管理更轻松</p>
    </div>
    
    <div class="features-grid">
      <!-- 普通功能卡片 -->
      <div class="feature-card" v-for="item in features" :key="item.id">
        <div class="card-header">
          <span class="feature-number">{{ item.number }}</span>
          <h4>{{ item.title }}</h4>
        </div>
        <p class="card-desc">{{ item.desc }}</p>
        <div class="icon-box">
          <!-- 这里统一用同一个图标，或者根据 item.icon 动态绑定 -->
          <img src="../assets/images/headphone-icon.png" alt="图标" class="feature-icon">
        </div>
      </div>
      
      <!-- 特殊样式的"更多功能"卡片 -->
      <div class="feature-card more-card">
        <h4 class="more-title">更多功能</h4>
        <ul class="more-list">
          <li v-for="(more, index) in moreFeatures" :key="index">
            <span class="check-icon">✓</span> {{ more }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

    <!-- 3. 硬件介绍 (浅灰背景，左文右图) -->
    <section class="cc-hardware">
      <div class="container">
        <div class="section-title">
          <h2>高清触控电子班牌终端</h2>
          <p class="sub-text">专为校园场景打造的智慧交互终端</p>
        </div>
        
        <div class="hardware-layout">
          <div class="hardware-text">
            <ul class="hw-list">
              <li v-for="hw in hardwareSpecs" :key="hw.title">
                <div class="hw-icon">
                  <img src="../assets/images/headphone-icon.png" alt="图标" class="list-icon">
                </div>
                <div>
                  <strong>{{ hw.title }}</strong>
                  <p>{{ hw.desc }}</p>
                </div>
              </li>
            </ul>
          </div>
          
          <div class="hardware-image">
            <div class="image-wrapper">
              <img src="../assets/images/class-card-device.png" alt="电子班牌终端" class="device-img">
            </div>
          </div>
        </div>
      </div>
    </section>

   <!-- 4. 核心优势 (极淡背景) -->
<section class="cc-advantages">
  <div class="container">
    <div class="section-title">
      <h2>核心优势</h2>
      <p>软硬件一体化，稳定可靠，持续进化</p>
    </div>
    <div class="adv-grid">
      <div class="adv-item" v-for="adv in advantages" :key="adv.id">
        <!-- 图片中优势部分没有图标，只有文字 -->
        <h4>{{ adv.title }}</h4>
        <p>{{ adv.desc }}</p>
      </div>
    </div>
  </div>
</section>

<!-- 5. 方案部署 (白色背景) -->
<section class="cc-deployment">
  <div class="container">
    <div class="section-title">
      <h2>方案部署</h2>
      <p>一体化部署方案，助力智慧校园落地</p>
    </div>
    <div class="deploy-steps">
      <template v-for="(step, index) in steps" :key="index">
        <div class="step-item" >
          <div class="step-icon-box">
            <!-- 请在此处引入您的小图标 -->
            <img :src="step.icon" :alt="step.title" class="step-icon">
          </div>
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>
        </div>
        <!-- 箭头：最后一个元素后不显示 -->
        <div class="step-arrow" v-if="index < steps.length - 1" :key="'arrow-'+index">→</div>
      </template>
    </div>
  </div>
</section>
    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'ElectronicClassCard',
  components: {  AppFooter },
  data() {
    return {
       features: [
      { id: 1, number: '01', title: '高清触控显示', desc: '1080P全高清IPS屏幕，10点电容触控，显示清晰，操作流畅。' },
      { id: 2, number: '02', title: '实时课表展示', desc: '动态更新课表信息、课程状态，随时掌握各班安排。' },
      { id: 3, number: '03', title: '班级文化风采', desc: '展示班级相册、荣誉榜、风采照片，营造积极向上的班级氛围。' },
      { id: 4, number: '03', title: '校园通知发布', desc: '学校通知、年级公共、班级消息精准苏打，重要信息不遗漏。' }, // 注意图片里这里也是03，可能是设计稿笔误，按图片写
      { id: 5, number: '05', title: '多端联动管理', desc: '支持PC端、移动端统一管理，数据互通，随时随地掌握班级动态。' }
    ],
    moreFeatures: [
      '班级值日管理',
      '班级作业管理',
      '家长留言展示',
      '班级信息展示',
      '节日倒计时',
      '空气质量/天气信息'
    ],
      hardwareSpecs: [
        {
          title: '高清大屏',
          desc: '10.1英寸IPS高清显示'
        },
        {
          title: '十点触控',
          desc: '电容触控，灵敏流畅，操作便捷'
        },
        {
          title: '稳定可靠',
          desc: '7×24小时稳定运行，适应复杂环境'
        },
        {
          title: '一体化设计',
          desc: '集成屏幕、主板、识别模块与软件系统'
        }
      ],
      advantages: [
      { id: 1, title: '自主研发', desc: '软硬件自主研发，深度适配教育场景需求。' },
      { id: 2, title: '高效稳定', desc: '工业级设计，7×24小时稳定运行。' },
      { id: 3, title: '数据安全', desc: '多重数据加密与权限管理，保障信息安全。' },
      { id: 4, title: '开放对接', desc: '提供标准API接口，对接校园平台更便捷。' }
    ],
    steps: [
      { title: '需求调研', desc: '深入了解学校需求', icon: require('@/assets/images/step1.png') }, // 替换为真实路径
      { title: '方案设计', desc: '定制化部署方案', icon: require('@/assets/images/step2.png') },
      { title: '设备安装', desc: '专业安装调试', icon: require('@/assets/images/step3.png') },
      { title: '系统上线', desc: '操作指导+上线支持', icon: require('@/assets/images/step4.png') },
      { title: '售后服务', desc: '持续运维保障', icon: require('@/assets/images/step4.png') }
    ]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped>
/* 全局变量 */
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px; 
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色) */
.cc-banner {
  position: relative;
  /* 背景图应该包含左侧走廊和右侧设备 */
  background-image: url('../assets/images/class-card-banner-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 80px 0;
  min-height: 600px;
  display: flex;
  align-items: center;
}

/* 渐变遮罩：左侧深色，右侧透明 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 从左到右：深色渐变到透明，让右侧设备清晰可见 */
  background: linear-gradient(to right, 
    rgba(15, 23, 42, 0.95) 0%, 
    rgba(15, 23, 42, 0.85) 40%, 
    rgba(15, 23, 42, 0.3) 70%,
    transparent 100%);
}

.cc-banner .container { 
  width: 100%;
}

.banner-content { 
  max-width: 650px;
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
}

.subtitle { 
  font-size: 24px; 
  color: rgba(255, 255, 255, 0.9); 
  margin-bottom: 50px; 
  font-weight: 500;
}

.banner-features { 
  display: flex; 
  gap: 25px; /* 减小间距 */
  flex-wrap: nowrap; /* 强制不换行 */
  justify-content: flex-start;
}

.bf-item { 
  display: flex; 
  align-items: flex-start; 
  gap: 10px;
  flex: 1; /* 平均分配空间 */
  max-width: none; /* 移除最大宽度限制 */
}

.bf-icon {
  flex-shrink: 0;
  width: 36px; /* 稍微减小图标 */
  height: 36px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bf-icon svg {
  width: 18px; /* 减小图标内部 */
  height: 18px;
  color: #fff;
}

.bf-item h4 {
  font-size: 14px; /* 稍微减小字号 */
  margin-bottom: 3px;
  color: #fff;
  font-weight: 600;
  white-space: nowrap; /* 不换行 */
}

.bf-item p {
  font-size: 11px; /* 稍微减小字号 */
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
  margin: 0;
}

@media (max-width: 992px) {
  .banner-content h1 {
    font-size: 40px;
  }
  
  .banner-features {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 16px;
  }
  
  .banner-features {
    flex-direction: column;
    gap: 20px;
  }
}
/* 2. Features (白色) */
/* 2. Features (白色背景区域) */
.cc-features { 
  padding: 80px 0; 
  background: #fff; 
}

.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px; 
}

.section-title { 
  text-align: center; 
  margin-bottom: 50px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #1e293b; 
  margin-bottom: 12px; 
  font-weight: bold;
  letter-spacing: 1px;
}

.section-title p { 
  color: #64748b; 
  font-size: 16px;
  margin: 0;
}

/* 网格布局 */
.features-grid { 
  display: grid; 
  grid-template-columns: repeat(3, 1fr); 
  gap: 24px; 
}

/* 普通卡片样式 */
.feature-card {
  background: #f4f8fb; /* 非常浅的蓝灰色背景 */
  padding: 30px; 
  border-radius: 12px; 
  text-align: left; /* 改为左对齐 */
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  min-height: 220px; /* 保证高度一致 */
}

.feature-card:hover { 
  transform: translateY(-5px); 
  box-shadow: 0 10px 30px rgba(0,0,0,0.05); 
}

/* 标题区域：序号 + 标题 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.feature-number {
  font-size: 18px;
  color: #1a9be6; /* 亮蓝色序号 */
  font-weight: bold;
  margin-right: 8px;
}

.feature-card h4 { 
  margin: 0; 
  /* color: #1e293b; */
  font-size: 18px;
  font-weight: bold;
}

.card-desc { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6;
  margin-bottom: 20px;
  flex-grow: 1; /* 让描述占据剩余空间，把图标推到底部 */
}

/* 图标区域 */
.icon-box { 
  margin-top: auto; /* 关键：将图标推到底部 */
}

.feature-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  /* 如果图片是黑色的，可以通过滤镜变蓝，如果是蓝色图片则不需要 */
  /* filter: invert(42%) sepia(93%) saturate(422%) hue-rotate(176deg) brightness(90%) contrast(90%); */
}

/* 更多功能卡片 - 亮蓝色 */
.more-card { 
  background: #1ca4eb; /* 还原图片中的亮蓝色 */
  color: #fff; 
  text-align: left; 
  padding: 30px;
  justify-content: flex-start;
}

.more-title {
  color: #fff;
  font-size: 20px;
  margin-bottom: 25px;
  font-weight: bold;
}

.more-list { 
  list-style: none; 
  padding: 0; 
  margin: 0;
}

.more-list li { 
  margin-bottom: 14px; 
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.check-icon {
  color: #fff;
  font-weight: bold;
  font-size: 14px;
}

/* 响应式 */
@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}

/* 3. Hardware (浅灰) */
.cc-hardware { 
  padding: 80px 0; 
  background: #f8fafc; 
}

.hardware-layout { 
  display: flex; 
  align-items: flex-start; 
  gap: 80px; 
  max-width: 1400px;
  margin: 0 auto;
}

.hardware-text { 
  flex: 1; 
}

.hw-list { 
  list-style: none; 
  padding: 0; 
  margin: 0;
}

.hw-list li { 
  display: flex; 
  gap: 20px; 
  margin-bottom: 30px;
  align-items: flex-start;
}

.hw-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-top: 3px;
}

.list-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.hw-list strong { 
  display: block; 
  color: #1e293b; 
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
}

.hw-list p { 
  font-size: 14px; 
  color: #64748b; 
  margin: 0;
  line-height: 1.5;
}

.hardware-image { 
  flex: 1; 
  display: flex; 
  justify-content: center;
}

.image-wrapper {
  position: relative;
  /* border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 30px;
  background: #fff; */
}

.device-img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

/* 响应式 */
@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .hardware-layout {
    flex-direction: column;
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .more-card {
    order: -1;
  }
}

/* 4. Advantages (白色) */
/* 4. Advantages (极淡蓝灰背景) */
.cc-advantages { 
  padding: 80px 0; 
  background: #f8fafc; /* 极淡的背景色 */
}

.cc-advantages .section-title h2 {
  color: #1e293b;
  font-size: 32px;
  margin-bottom: 10px;
}

.cc-advantages .section-title p {
  color: #64748b;
  font-size: 16px;
}

.adv-grid { 
  display: flex; 
  justify-content: space-between; 
  gap: 20px; 
  margin-top: 40px;
}

.adv-item { 
  flex: 1; 
  text-align: center; 
  padding: 20px; 
}

/* 优势标题改为蓝色 */
.adv-item h4 { 
  margin-bottom: 12px; 
  color: #1995d3; /* 蓝色标题 */
  font-size: 18px;
  font-weight: bold;
}

.adv-item p { 
  font-size: 16px; 
  color: #64748b; 
  line-height: 1.6;
}

/* 5. Deployment (白色背景) */
.cc-deployment { 
  padding: 80px 0; 
  background: #fff; 
}

.cc-deployment .section-title h2 {
  color: #1e293b;
  font-size: 32px;
  margin-bottom: 10px;
}

.deploy-steps { 
  display: flex; 
  justify-content: center; /* 居中排列 */
  align-items: flex-start;
  position: relative;
  margin-top: 50px;
  gap: 30px; /* 步骤之间的间距 */
}

.step-item { 
  flex: 1; 
  text-align: center; 
  max-width: 160px; /* 限制宽度防止太宽 */
}

/* 蓝色圆形图标背景 */
.step-icon-box {
  width: 64px;
  height: 64px;
  background: #1995d3; /* 深蓝色背景 */
  border-radius: 50%;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2); */
}

.step-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
  /* 如果图标是白色的，不需要滤镜；如果是黑色的，可以加 filter: brightness(0) invert(1); */
}

.step-item h4 { 
  color: #1e293b; 
  font-size: 16px; 
  margin-bottom: 8px;
  font-weight: 600;
}

.step-item p {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* 箭头样式 */
.step-arrow {
  color: #94a3b8; /* 浅灰色箭头 */
  font-size: 24px;
  font-weight: bold;
  margin-top: 15px; /* 微调垂直位置，对齐图标中心 */
  flex-shrink: 0;
}

/* 响应式 */
@media (max-width: 992px) {
  .deploy-steps {
    flex-wrap: wrap;
    gap: 30px;
  }
  .step-arrow {
    display: none; /* 手机端隐藏箭头或改为向下 */
  }
  .step-item {
    flex: 0 0 45%;
  }
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>